<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="utf-8">
    <meta content="width=device-width, initial-scale=1.0" name="viewport">

    <title>VNSGU - Index</title>
    <meta content="" name="description">
    <meta content="" name="keywords">

    <!-- Favicons -->
    <link href="/assets/frontpage/img/favicon.png" rel="icon">
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">

    <!-- Google Fonts -->
    <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,700,700i|Raleway:300,400,500,700,800" rel="stylesheet">

    <!-- Vendor CSS Files -->
    <link href="/assets/frontpage/vendor/aos/aos.css" rel="stylesheet">
    <link href="/assets/frontpage/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
    <link href="/assets/frontpage/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
    <link href="/assets/frontpage/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
    <link href="/assets/frontpage/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

    <!-- Template Main CSS File -->
    <link href="/assets/frontpage/css/style.css" rel="stylesheet">


</head>

<body>

    <!-- ======= Header ======= -->
    <header id="header" class="d-flex align-items-center ">
        <div class="container-fluid container-xxl d-flex align-items-center">

            <div id="logo" class="me-auto">
                <!-- Uncomment below if you prefer to use a text logo -->
                <!-- <h1><a href="index.html">The<span>Event</span></a></h1>-->
                <a href="index.html" class="scrollto"><img src="/assets/frontpage/img/logo.png" alt="" title=""></a>
            </div>
            <div class="logo">
                <img src="/assets/frontpage/img/frc/frc-logo.png" alt="" class="img-fluid">
            </div>
        </div>
    </header>
    <!-- End Header -->
    <div class="header-navbar-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-,d-12 col-sm-12 col-xs-12">

                    <div class="main-header">

                        <div class="container">
                            <nav class="navbar  p-0 main-navigation">

                                <div class="header-navigation-area justify-content-between ml-auto">

                                    <ul id="main-menu left-menu" class="menu m-0">

                                        <li><a href="index.html">Home</a></li>

                                        <li class="menu-item-has-children">
                                            <a href="#">Committee <i class="fa fa-angle-down" aria-hidden="true"></i></a>
                                            <ul class="sub-menu">
                                                <li><a href="">General Information</a></li>
                                                <li><a href="">Members</a></li>
                                            </ul>
                                        </li>

                                    </ul>
                                    <ul id="main-menu right-menu" class="menu m-0">
                                        <!-- <li class="menu-item-has-children">
                                            <a href="#">register <i class="fa fa-angle-down" aria-hidden="true"></i></a>
                                            <ul class="sub-menu">
                                                <li><a href="">General Information</a></li>
                                                <li><a href="">Members</a></li>
                                            </ul>
                                        </li> -->
                                        <li><a href="#" routerLink="/login">Register</a></li>


                                        <li class="menu-item-has-children">
                                            <a href="#" class="btn-download">Login</a>
                                            <ul class="sub-menu">
                                                <li><a href="" routerLink="/login">College Login</a></li>
                                                <li><a href="" routerLink="/aciadmin">Admin Login</a></li>
                                            </ul>
                                        </li>

                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>


                </div>
            </div>
        </div>

    </div>

    <main id="main">
        <div class="frc-slider-section">
            <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="6" aria-label="Slide 7"></button>
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img src="/assets/frontpage/img/banner/1.jpg" class="d-block w-100" alt="">
                    </div>
                    <div class="carousel-item">
                        <img src="/assets/frontpage/img/banner/2.jpg" class="d-block w-100" alt="">
                    </div>
                    <div class="carousel-item">
                        <img src="/assets/frontpage/img/banner/3.jpg" class="d-block w-100" alt="">
                    </div>
                    <div class="carousel-item">
                        <img src="/assets/frontpage/img/banner/4.jpg" class="d-block w-100" alt="">
                    </div>

                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
            </div>
        </div>

        <div class="frc-rules-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                        <div class="frc-image-section">
                            <img src="/assets/frontpage/img/frc/about.png" alt="" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                        <div class="frc-content-section" style="width: 100%;left: -30%;">
                            <div class="section-header">
                                <h2>Acts, Rules & amendments</h2>
                            </div>
                            <div class="frc-document-section">
                                <ul>
                                    <li>
                                        <div class="document-section">
                                            <p>Comming soon....</p>
                                            <!-- <p>The Gujarat Self financed Schools (Regulation of Fees) Act,2017</p>
                                            <a href="" class="btn-dowmload">Download</a> -->
                                        </div>
                                    </li>
                                </ul>
                                <!-- <div class="btn-section text-right">
                                    <a href="" class="btn-comman">View All</a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!------------FAQ section design---------------->
        <div class="faq-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                        <div class="notice-section">
                            <div class="section-header">
                                <h2>Notice</h2>
                            </div>
                            <div class="notice-detail">
                                <ul>
                                    <li>
                                        <h3><p>Comming soon....</p></h3>
                                    </li>
                                </ul>
                                <!-- <div class="btn-section">
                                    <a href="" class="btn-comman">View All</a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8 col-md-7 col-sm-12 col-xs-12">
                        <div class="faq-detail-section">
                            <div class="section-header">
                                <h2>FAQs</h2>
                            </div>
                            <div class="faq-information">
                                <div class="question-section">
                                    <p class="question"><span>Q)</span>Which purpose is to use this application?</p>
                                    <p class="ans">To request the regarding college details like a, (Employee Details, Scholarship Details, Expenses Details etc.)from using this application.</p>
                                </div>
                                <div class="question-section">
                                    <p class="question"><span>Q)</span>From Which Academic year the provisions of this Act/Rule is applicable ?</p>
                                    <p class="ans">From the Academic year 2021-2022</p>
                                </div>
                            </div>
                            <!-- <div class="btn-section">
                                <a href="" class="btn-comman">View All</a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fees-process-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="section-header">
                            <h2>Fee Determination Process</h2>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                        <div class="process-section">
                            <img src="/assets/frontpage/img/frc/fees-process.png" alt="" class="img-fluid web">
                            <img src="/assets/frontpage/img/frc/Fee-Process-mobile.png" alt="" class="img-fluid mobile">
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </main>
    <!-- End #main -->

    <!-- ======= Footer ======= -->
    <footer id="footer">
        <div class="footer-top">
            <div class="container">
                <div class="row">

                    <div class="col-lg-4 col-md-4 footer-info">
                        <img src="/assets/frontpage/img/Footer-logo.png" alt="">

                    </div>



                    <div class="col-lg-8 col-md-8 footer-contact">
                        <h4>Contact Us</h4>
                        <div class="contact-detail">
                            <div class="address">
                                <p>
                                    Veer Narmad South Gujarat University,<br/> Udhana - Magdalla Rd,<br/> Surat, Gujarat 395007<br>

                                </p>
                            </div>
                            <div class="address">
                                <p>
                                    <strong>Phone:</strong> +91 (0261) 2227141 to 2227146<br>
                                    <strong>Digital Helpline:</strong> +91 (0261) 2388888<br>
                                    <strong>Email:</strong> info@vnsgu.ac.in<br>
                                </p>
                            </div>
                            <div class="social-links">
                                <a href="https://twitter.com/VNSGUNIVERSITY" target="_blank" class="twitter"><i class="bi bi-twitter"></i></a>
								<a href="https://www.facebook.com/VNSGUNIVERSITY/" target="_blank" class="facebook"><i class="bi bi-facebook"></i></a>
                                <a href="https://www.instagram.com/vnsguofficial/" target="_blank" class="instagram"><i class="bi bi-instagram"></i></a>
                                <a href="https://wa.me/912612388888" target="_blank" class="whatsapp"><i class="bi bi-whatsapp"></i></a>
                                <a href="https://www.youtube.com/c/VNSGUOfficial" target="_blank" class="youtube"><i class="bi bi-youtube"></i></a>
                            </div>
                        </div>



                    </div>

                </div>
            </div>
        </div>

        <div class="container">
            <div class="copyright">
                &copy; Copyright <strong>VNSGU</strong>. All Rights Reserved
            </div>

        </div>
    </footer>
    <!-- End  Footer -->

    <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

    <!-- Vendor JS Files -->
    <script src="/assets/frontpage/js/jquery-3.3.1.min.js"></script>
    <script src="/assets/frontpage/vendor/aos/aos.js"></script>
    <script src="/assets/frontpage/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
    <script src="/assets/frontpage/vendor/glightbox/js/glightbox.min.js"></script>
    <script src="/assets/frontpage/vendor/php-email-form/validate.js"></script>
    <script src="/assets/frontpage/vendor/swiper/swiper-bundle.min.js"></script>

    <!-- Template Main JS File -->
    <script src="/assets/frontpage/js/main.js"></script>
    <!-- <script>
        (function($) {
            "use strict";
            var PUS = {};
            /*==========================================
                    :: slicknav
            ==========================================*/
            PUS.slicknav = function() {
                $("#main-menu").slicknav({
                    allowParentLinks: true,
                    prependTo: '#mobile-menu-wrap',
                    label: '',
                });

                $(".mobile-menu-trigger").on("click", function(e) {
                    $(".mobile-menu-container").addClass("menu-open");
                    e.stopPropagation();
                });

                $(".mobile-menu-close").on("click", function(e) {
                    $(".mobile-menu-container").removeClass("menu-open");
                    e.stopPropagation();
                });
            };
            $(document).ready(function() {
                PUS.slicknav();
            });
        })(jQuery);
    </script> -->

</body>

</html>